import { BrowserRouter, Route, Routes as WrapperRoutes } from 'react-router-dom'
import ModalDetalhesVagas from '../components/ModalDetalhesVagas'
import ComponentePrivado from '../middlewares/componentePrivado'
import Cobranca from '../pages/Cobranca'
import Contato from '../pages/Contato'
import Gesttor from '../pages/Gesttor'
import Home from '../pages/Home'
import LinkPro from '../pages/LinkPro'
import Links from '../pages/Links'
import PoliticaPrivacidade from '../pages/PoliticaPrivacidade'
import PortalAuth from '../pages/PortalAuth'
import PortalCandidato from '../pages/PortalCandidato'
import PortalVagas from '../pages/PortalVagas/PortalVagas'
import ProcessosInscritosPage from '../pages/ProcessosInscritos'
import TermosDeUso from '../pages/TermosUso'

function Routes () {
    return (
        <BrowserRouter>
            <WrapperRoutes>
                <Route path='*' element = { <Home /> } />
                <Route path='/' element = { <Home /> } />
                <Route path='/contato' element = { <Contato />} />
                <Route path='/gesttor' element= {<Gesttor/>} />
                <Route path='/linkpro' element= {<LinkPro/>} />
                <Route path='/cobranca/:idCliente' element = { <Cobranca />} />
                <Route path='/politicaprivacidade' element = {<PoliticaPrivacidade />} />
                <Route path='/termosuso' element={<TermosDeUso />} />
                <Route path='/portal-auth' element={<PortalAuth/>}/>
                <Route path='/portal-candidato' element={<ComponentePrivado><PortalCandidato/></ComponentePrivado>}/>
                <Route path="/vagas" element={<PortalVagas />}>
                    <Route path=":idVaga" element={<ModalDetalhesVagas />} />
                </Route>
                <Route path='/vagas' element={<PortalVagas/>}/>
                <Route path='/links' element={<Links/>}/>
                <Route path='/processos-inscritos' element={<ComponentePrivado><ProcessosInscritosPage /></ComponentePrivado>} >
                    <Route path=":idVaga" element={<ModalDetalhesVagas/>} />
                </Route>
            </WrapperRoutes>
        </BrowserRouter>
    )
}

export default Routes